import { nodes } from '../Flow/Flow.data'
import React from 'react'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import s from './FlowLogEvent.scss'
import { moment } from 'features/Moment'
import { Row, Col } from 'components/Layout'
import { PrettyJson } from 'components/PrettyJson'
import sMarg from 'styles/modules/margins.scss'

export const FlowLogEvent = ({ event }) => {
  const nodeInfo = nodes[event.type]

  return (
    <div className={s.card}>
      <div className={s.title}>
        <nodeInfo.icon />
        <div className={cn(sLay.flex, s.label)}>{nodeInfo.label}</div>
        {moment(event.timestamp).format('DD MMM YYYY, h:mm:ss a')}
      </div>
      <div className={s.body}>
        <Row className={cn(sLay['layout-gt-xs-row'], 'sm')}>
          <Col className={cn(sLay['flex-gt-xs-50'], sLay['layout-column'], 'sm')}>
            <PrettyJson data={event.config} className={sLay.flex} title="Config" />
          </Col>
          <Col className={cn(sLay['flex-gt-xs-50'], sLay['layout-column'], 'sm')}>
            <PrettyJson data={event.result} className={sLay.flex} title="Output" />
          </Col>
        </Row>
        {event.error && Object.keys(event.error).length > 0 && (
          <PrettyJson data={event.error} className={cn(sMarg.mt15, s.error)} title="Error" />
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/Flows/FlowLogEvent/FlowLogEvent.jsx